import { useEffect, useState } from 'react';
import { usePageTitle } from './PageTitleContext';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import BackofficeSidebar from '../components/BackofficeSidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { eventBus } from '../bus/eventBus';
import useTablerIconsReady from '../hooks/useTablerIconsReady';

export default function BackofficeLayout() {
    const { title, titleIcon, titleAvatar, titleBadge, titleDescription } = usePageTitle();
    const navigate = useNavigate();
    const location = useLocation();
    // collapses the title bar while a listing table below is scrolled down, to free up
    // vertical space — mirrors MainLayout, fed by the same Table.js scroll events
    const [headerHidden, setHeaderHidden] = useState(false);

    useTablerIconsReady();

    useEffect(() => {
        const handler = (visible) => setHeaderHidden(!visible);
        eventBus.on('listingChromeVisibility', handler);
        return () => eventBus.off('listingChromeVisibility', handler);
    }, []);

    useEffect(() => { setHeaderHidden(false); }, [location.pathname]);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            {/* Sidebar */}
            <div style={{ flexShrink: 0, height: '100vh' }}>
                <BackofficeSidebar />
            </div>

            {/* Zone centrale */}
            <div style={{
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                height: '100vh',
                overflow: 'hidden'
            }}>

                {/* Header */}
                <div style={{
                    flexShrink: 0,
                    minHeight: headerHidden ? 0 : 64,
                    maxHeight: headerHidden ? 0 : 100,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: headerHidden ? '0 20px' : '10px 20px',
                    background: '#fff',
                    borderBottom: headerHidden ? 'none' : '1px solid #f0f0f0',
                    gap: 12,
                    overflow: 'hidden',
                    opacity: headerHidden ? 0 : 1,
                    transition: 'max-height 0.25s ease, min-height 0.25s ease, opacity 0.2s ease, padding 0.25s ease',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <button
                            onClick={() => navigate(-1)}
                            style={{
                                border: 'none',
                                background: '#f0f0f0',
                                cursor: 'pointer',
                                width: 32,
                                height: 32,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                transition: 'background-color 0.2s ease',
                            }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dedede'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                            aria-label="Go back"
                        >
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        {titleAvatar ? (
                            titleAvatar
                        ) : titleIcon && (
                            <span style={{
                                width: 35, height: 35, borderRadius: '50%', flexShrink: 0,
                                background: '#f0f0f0', color: '#111827',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 16,
                            }}>
                                <i className={`ti ${titleIcon}`} />
                            </span>
                        )}
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <h3
                                    style={{ fontSize: '15px', fontWeight: 700, margin: 0 }}
                                    dangerouslySetInnerHTML={{ __html: title }}
                                />
                                {titleBadge}
                            </div>
                            {titleDescription && (
                                <div style={{ fontSize: 12, fontWeight: 400, color: '#9ca3af', marginTop: 5 }}>
                                    {titleDescription}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Contenu central */}
                <div style={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden'
                }}>
                    <Outlet />
                </div>

            </div>
        </div>
    );
}
